import * as Msdyn365 from '@msdyn365-commerce/core';

export interface ISetVerificationEmailResponse {
    success: boolean;
}

interface ISetVerificationEmailData {
    '@odata.context': string;
    value: boolean;
}

export class SetVerificationEmailInput implements Msdyn365.IActionInput {
    public email: string;
    public language: string;
    constructor(email: string, language: string) {
        this.email = email;
        this.language = language;
    }
    public getCacheKey = () => `SetVerificationEmailInput-${this.email}`;
    public getCacheObjectType = () => 'SetVerificationEmailInput';
    public dataCacheType = (): Msdyn365.CacheType => 'none';
}

const createInput = (_args: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    return new SetVerificationEmailInput('', '');
};

async function action(input: SetVerificationEmailInput, ctx: Msdyn365.IActionContext): Promise<ISetVerificationEmailResponse> {
    try {
        const response = await Msdyn365.sendRequest<ISetVerificationEmailData>(
            `${ctx.requestContext.apiSettings.baseUrl}Commerce/SetVerificationEmail`,
            'post',
            {
                email: input.email,
                language: input.language
            },
            {
                headers: {
                    OUN: ctx.requestContext.apiSettings.oun
                }
            }
        );

        return {
            success: response.status === 200 && response.data?.value === true
        };
    } catch (error) {
        console.error('SetVerificationEmail failed.', error);
        return { success: false };
    }
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<ISetVerificationEmailResponse>>action,
    id: 'PostSetVerificationEmail',
    input: createInput
});
